/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import { CreateLeadsDetails } from "src/helpers/FormDetails/CreateDetails/interfaces";
import axiosInstance from "src/utils/Axios/axiosInstance";

const createLeadAPI = async (body: CreateLeadsDetails) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.createLead}`, body);
    return response;
  } catch (response: any) {
    throw new Error(response);
  }
};

export const getMasterPolicy = async (
  productId: number | undefined,
  partnerID: string,
  isStaffMember: boolean,
  lifeInsurerAge: number,
  loanCategory: string
) => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.policyNumber, {
      params: {
        partnerId: partnerID,
        productId,
        isStaffJourney: isStaffMember,
        age: lifeInsurerAge,
        loanType: loanCategory
      }
    });
    return { ...response };
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export default createLeadAPI;
